// @ts-check
import _ from 'lodash';
import { combineReducers } from 'redux';
import {
  REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_PROVIDED,
  REFERRAL_DASHBOARD_RESULTS_FETCHING,
  REFERRAL_DASHBOARD_RESULTS_RECEIVED,
  REFERRAL_DASHBOARD_PAGE_SLOTS_FETCHING,
  REFERRAL_DASHBOARD_PAGE_SLOTS_RECEIVED,
  REFERRAL_DASHBOARD_PAGE_MOUNTED,
  REFERRAL_DASHBOARD_RESULTS_FETCH_FAILED,
  REFERRAL_DASHBOARD_RESULTS_FETCH_CANCELLED,
} from 'shared/actions/ReferralProfiles/ReferralDashboardActions';

const initialPageState = {
  referralProfileId: null, // As SPA, this might or might not be pageState for here
  currentResults: [], // ordered id's of results to show on page
  isFetching: false,
  range: '30',
  fetchingPage: null,
  currentPage: 1,
  totalPages: 0,
  lastUpdated: null,
  searchTerm: '',
  specialtyId: null,
  fetchingSearchTerm: '',
  outOfGroupReason: null,
  ageClassification: null,
  network: null,
};

function pageState(state = initialPageState, action) {
  switch (action.type) {
    case REFERRAL_DASHBOARD_PAGE_MOUNTED:
      return initialPageState;
    case REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_PROVIDED:
      return { ...state, outOfGroupReason: action.reason };
    case REFERRAL_DASHBOARD_RESULTS_FETCHING:
      return Object.assign({}, state, {
        isFetching: true,
        fetchingPage: action.page,
        fetchingSearchTerm: action.searchTerm,
      });

    case REFERRAL_DASHBOARD_RESULTS_RECEIVED: {
      return Object.assign({}, state, {
        isFetching: false,
        fetchingPage: null,
        referralProfileId: action.referralProfile,
        currentPage: action.page,
        totalPages: action.totalPages,
        lastUpdated: action.receivedAt,
        searchTerm: action.searchTerm,
        specialtyId: action.specialtyId,
        range: action.range,
        ageClassification: action.ageClassification,
        currentResults:
          action.page === 1
            ? action.matchingResultIds
            : _.union(state.currentResults, action.matchingResultIds),
        network: action.network,
        organizationReferralRejected: action.organizationReferralRejected,
      });
    }

    case REFERRAL_DASHBOARD_RESULTS_FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        fetchingPage: null,
        // TODO: error: action.error?
      };

    case REFERRAL_DASHBOARD_RESULTS_FETCH_CANCELLED:
      return {
        ...state,
        isFetching: false,
        fetchingPage: null,
      };

    default:
      return state;
  }
}

function matchingResults(state = {}, action) {
  switch (action.type) {
    case REFERRAL_DASHBOARD_PAGE_MOUNTED:
      return {};
    case REFERRAL_DASHBOARD_RESULTS_RECEIVED: {
      const results = _.mapValues(action.entities.matchingResults, r => ({
        isFetchingSlots: false,
        ...r,
      }));
      if (action.page === 1) {
        return results;
      }
      return _.merge({}, state, results);
    }

    case REFERRAL_DASHBOARD_PAGE_SLOTS_FETCHING:
      return {
        ...state,
        [action.resultId]: {
          ...state[action.resultId],
          isFetchingSlots: true,
        },
      };

    case REFERRAL_DASHBOARD_PAGE_SLOTS_RECEIVED:
      return {
        ...state,
        [action.resultId]: {
          ...state[action.resultId],
          isFetchingSlots: false,
          ...action.slots,
        },
      };

    default:
      return state;
  }
}

function referralProfiles(state = {}, action) {
  switch (action.type) {
    case REFERRAL_DASHBOARD_PAGE_MOUNTED:
      return {};
    case REFERRAL_DASHBOARD_RESULTS_RECEIVED:
      if (action.page === 1) {
        return action.entities.referralProfiles || {};
      }
      return _.merge({}, state, action.entities.referralProfiles);
    default:
      return state;
  }
}

function providers(state = {}, action) {
  switch (action.type) {
    case REFERRAL_DASHBOARD_PAGE_MOUNTED:
      return {};
    case REFERRAL_DASHBOARD_RESULTS_RECEIVED:
      if (action.page === 1) {
        return action.entities.providers || {};
      }
      return _.merge({}, state, action.entities.providers);

    default:
      return state;
  }
}

function locations(state = {}, action) {
  switch (action.type) {
    case REFERRAL_DASHBOARD_PAGE_MOUNTED:
      return {};
    case REFERRAL_DASHBOARD_RESULTS_RECEIVED:
      if (action.page === 1) {
        return action.entities.locations || {};
      }
      return _.merge({}, state, action.entities.locations);

    default:
      return state;
  }
}

const entities = combineReducers({
  referralProfiles,
  matchingResults,
  providers,
  locations,
});

export default combineReducers({
  pageState,
  entities,
});
